import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function InsightDetail() {
    const { slug } = useParams();
    const [item, setItem] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        api.get(`/insights/${slug}`).then((r) => setItem(r.data)).catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) {
        return (
            <PageShell navVariant="light">
                <div className="pt-32 pb-24 text-center">
                    <h1 className="font-serif text-4xl">Article not found</h1>
                    <Link to="/insights" className="overline mt-6 inline-block link-gold">Back to insights</Link>
                </div>
            </PageShell>
        );
    }
    if (!item) {
        return <PageShell navVariant="light"><div className="pt-32 pb-24 text-center text-black/40">Loading article…</div></PageShell>;
    }

    return (
        <PageShell navVariant="light">
            <div className="pt-28 md:pt-32">
                <div className="max-w-3xl mx-auto px-6 py-12">
                    <Link to="/insights" data-testid="insight-back" className="overline text-black/60 inline-flex items-center gap-2 link-gold mb-8"><ArrowLeft size={14}/> Back to insights</Link>
                    <div className="flex items-center gap-3">
                        <span className="overline text-[var(--ebg-gold)]">{item.category}</span>
                        <span className="w-1 h-1 bg-[var(--ebg-gold)]" />
                        <span className="overline text-black/50">{item.read_time}</span>
                    </div>
                    <h1 className="font-serif text-4xl md:text-6xl leading-[1.05] mt-6">{item.title}</h1>
                    <div className="mt-6 flex items-center gap-3 text-sm text-black/60">
                        <span>By {item.author}</span>
                    </div>
                </div>

                <div className="max-w-5xl mx-auto px-6 mb-12">
                    <img src={item.cover_image} alt={item.title} className="w-full aspect-[16/9] object-cover" />
                </div>

                <div className="max-w-3xl mx-auto px-6 pb-24">
                    <p className="text-lg text-black/75 leading-8 font-serif italic">{item.excerpt}</p>
                    <div className="mt-8 space-y-6 text-black/80 leading-8">
                        {item.body.split("\n\n").map((para, i) => <p key={i}>{para}</p>)}
                    </div>
                </div>
            </div>
        </PageShell>
    );
}
